<template>
  <div class="product-edit" >
    <md-card>
      <md-card-header>
        <div class="md-title" v-if="product._id">{{ product.name }}</div>
        <translate tag="div" class="md-title" v-else>Add New Product</translate>
        <translate tag="div" class="md-caption">Set basic information here</translate>
      </md-card-header>

      <md-card-content>
          <form novalidate @submit.stop.prevent="submit">

            <md-layout md-gutter="16">
              <md-layout>
                <md-input-container :class="{'md-input-invalid': !validName(product.name) && nameDirty }">
                  <md-icon>announcement</md-icon>
                  <translate tag="label">Name of product</translate>
                  <md-input id="product-name-input" @input.native="nameDirty = true" type="text" v-model="product.name" :value="product.name" required></md-input>
                  <span class="md-error"><translate>Name must be filled</translate></span>
                </md-input-container>
              </md-layout>
              <md-layout>
                <md-input-container :class="{'md-input-invalid': !validCustomId(product.customId) && customIdDirty }">
                  <md-icon>label</md-icon>
                  <translate tag="label">Product Code</translate>
                  <md-input id="product-id-input" @input.native="customIdDirty = true" type="text" v-model="product.customId" :value="product.customId" required></md-input>
                  <span class="md-error"><translate>Product code must be filled</translate></span>
                </md-input-container>
              </md-layout>
            </md-layout>

            <md-layout>
                <md-input-container>
                  <md-icon>speaker_notes</md-icon>
                  <translate tag="label">Description</translate>
                  <md-textarea maxlength="1000" type="text" v-model="product.description"></md-textarea>
                </md-input-container>
            </md-layout>

          </form>
      </md-card-content>

      <md-card-actions>
        <md-button @click.native="cancelForm()"><translate>Cancel</translate></md-button>
        <md-button id="submit-product" class="md-raised md-primary" @click.native="submit()"><translate>Save</translate></md-button>
      </md-card-actions>

      <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="4000">
        <translate>The specified Product name already exists</translate>
        <md-button @click.native="$refs.snackbar.close()"><translate>Close</translate></md-button>
      </md-snackbar>
    </md-card>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'product-form',
  data () {
    return {
      nameDirty: false,
      customIdDirty: false
    }
  },
  props: [ 'product' ],
  async created () {
    if (this.product._id !== undefined) { // fetch the latest version of product from the server
      await this.$store.dispatch('fetchOneProduct', this.product._id)
    }
  },
  computed: {
    ...mapGetters([
      'allProducts'
    ])
  },
  methods: {
    ...mapMutations([
      'productCancelEdit'
    ]),
    ...mapActions([
      'saveProduct'
    ]),
    nameExists (name) {
      return this.allProducts.some((prod) => {
        return prod.name === name && prod._id !== this.product._id
      })
    },
    async submit () {
      this.nameDirty = true
      this.customIdDirty = true
      if (this.validName(this.product.name) && this.validCustomId(this.product.customId)) {
        if (this.nameExists(this.product.name)) {
          this.$refs.snackbar.open()
        } else {
          await this.saveProduct()
          this.$router.push({ name: 'tab-2' })
        }
      }
    },
    cancelForm () {
      this.$router.push({ name: 'tab-2' })
      this.productCancelEdit()
    },
    validName (name) {
      return name !== ''
    },
    validCustomId (customId) { // TODO validate customId
      return customId !== ''
    }
  }
}
</script>

<style scoped>
.product-edit {
  max-width: 1000px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/products/Form.vue